<template>
  <div class="bad">
    <div class="sorry">
      <div class="bad-title">{{ $tr('badBrowser.yourBrowserIsSludge') }}</div>
      <p>{{ $tr('badBrowserIos.description') }}</p>
    </div>

    <div class="what-to-do-container">
      <div class="what-to-do">
        <div class="bad-subtitle">{{ $tr('badBrowser.whatDoIDo') }}</div>

        <ul class="steps">
          <li>
            <div class="container">
              <div class="list-block">
                <span class="number">1&nbsp;</span>
                <p>{{ $tr('badBrowser.copyLink') }}</p>
              </div>

              <div class="link">
                <div class="link-content">{{currentUrl}}</div>
                <button
                  class="vcv-button iconed gray right-button"
                  @click="copyLinkToClipboard(currentUrl)"
                  v-tooltip.top-center="$tr('vacancy.preferences.settings.copyToClipboard')"
                >
                  <i class="icon icon-copy"></i>
                  <span>{{ $tr('vacancy.preferences.settings.copy') }}</span>
                </button>
              </div>
            </div>
          </li>

          <li>
            <div class="container">
              <div class="list-block">
                <span class="number">2&nbsp;</span>
                <p>{{ $tr('badBrowserIos.putLink') }}</p>
              </div>
            </div>
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script>
import CopyTextToClipboard from '@/components/mixin/CopyTextToClipboard.js'

export default {
  name: 'BadBrowser',

  mixins: [
    CopyTextToClipboard
  ],

  methods: {
    copy (arg) {
      this.copyLinkToClipboard(arg)
    }
  },

  computed: {
    currentUrl () {
      return window.location.href
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .bad {
    width: 100%;
    padding: 1.1rem 1rem;
    box-sizing: border-box;
    max-width: 500px;

    h1,
    p,
    ul,
    li {
      margin: 0;
      padding: 0;
    }

    li {
      list-style: none;
      margin-bottom: 16px;
    }

    .sorry {
      text-align: center;
      margin-bottom: 32px;

      p {
        font-size: 15px;
        line-height: 24px;
      }
    }

    .what-to-do-container {
      width: 100%;
    }

    // .what-to-do {
    //
    // }

    .bad-title {
      margin-bottom: 1.25rem;
      font-size: 24px;
      line-height: 32px;
      font-weight: bold;
      text-align: center;
    }

    .bad-subtitle {
      font-weight: bold;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 20px;
    }

    .number {
      display: block;
      margin-right: 5px;
      font-weight: 500;
      font-size: 15px;
      line-height: 20px;
      color: $green;
    }

    .container {
      width: 100%;

      p {
        // margin-bottom: 8px;
        // padding-top: 4px;
        font-weight: bold;
        font-size: 15px;
        line-height: 20px;

        &.center {
          padding-top: 36px;
          text-align: center;
        }
      }

      .browsers {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 52px;

        .browser {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;

          &:hover {
            color: inherit;
          }

          img {
            width: 74px;
            height: 74px;
            margin-bottom: 6px;
          }
        }
      }
    }

    .link {
      .registrationLink {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      .vcv-button {
        width: 100%;
        border-radius: 2px;
        background: #fff !important;
        max-width: 480px;
      }
    }
  }

  .list-block {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .link {
    text-align: center;
  }

  .link-content {
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 6px;
    color: #233346;
    max-width: 100%;
    word-break: break-word;
  }
</style>
